import Vue from 'vue'
import ViewRouter from 'vue-router'
import LeaderboardCard from "../components/LeaderboardCard";
import Administration from "../views/Administration";
import HistoryView from "../views/HistoryView";
import Login from "../views/Login";
import OnlineUsersCard from "../components/OnlineUsersCard";
import Statistics from "@/views/Statistics";
import UserProfileView from "../views/UserProfileView";
import WeatherCard from "../components/WeatherCard";
import Dashboard from '../views/Dashboard'

Vue.use(ViewRouter)
Vue.router = new ViewRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Dashboard
        },
        {
            path: '/home',
            name: 'home',
            component: Dashboard
        },
        {
            path: '/weather-card',
            name: 'weather-card',
            component: WeatherCard
        },
        {
            path: '/online-users',
            name: 'online-users',
            component: OnlineUsersCard
        },
        {
            path: '/leaderboard',
            name: 'leaderboard',
            component: LeaderboardCard,
            props: { showAllInitial: true }
        },
        {
            path: '/statistics',
            name: 'statistics',
            component: Statistics
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/user-profile',
            name: 'user-profile',
            component: UserProfileView,
            meta: {
                auth: true
            }
        },
        {
            path: '/history',
            name: 'history',
            component: HistoryView,
            meta: {
                auth: true
            }
        },
        {
            path: '/administration',
            name: 'administration',
            component: Administration,
            meta: {
                auth: true
            }
        },
        {
            path: '/:catchAll(.*)',
            component: Dashboard,
            name: 'notFound'
        }
    ]
});

export default Vue.router;